import { render } from "./DadosEmpresa.vue?vue&type=template&id=19952bc1&scoped=true"
import script from "./DadosEmpresa.vue?vue&type=script&lang=js"
export * from "./DadosEmpresa.vue?vue&type=script&lang=js"

import "./DadosEmpresa.vue?vue&type=style&index=0&id=19952bc1&lang=scss&scoped=true"
import "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&external"
import "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=2&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19952bc1"]])

export default __exports__